'use client';

import { c as _c } from "react/compiler-runtime";
import { useDeferredValue } from 'react';
import { type MarketDetailDataProps, MarketDetailLayoutView } from '@/components/market/market-detail-layout';
import { useMarketPositions, useOwnedMarketPositionScope } from '@/hooks/positions/use-market-positions';
export function MarketDetailPositionBoundary(props) {
  const $ = _c(8);
  const ownedPositionScope = useOwnedMarketPositionScope();
  let t0;
  if ($[0] !== ownedPositionScope.userId || $[1] !== ownedPositionScope.walletPubkeys || $[2] !== props.marketPubkey) {
    t0 = {
      userId: ownedPositionScope.userId,
      walletPubkeys: ownedPositionScope.walletPubkeys,
      market: props.marketPubkey
    };
    $[0] = ownedPositionScope.userId;
    $[1] = ownedPositionScope.walletPubkeys;
    $[2] = props.marketPubkey;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const marketPositions = useMarketPositions(t0);
  const deferredMarketPositions = useDeferredValue(marketPositions);
  let t1;
  if ($[4] !== deferredMarketPositions || $[5] !== ownedPositionScope || $[6] !== props) {
    t1 = <MarketDetailLayoutView {...props} ownedPositionScope={ownedPositionScope} marketPositions={deferredMarketPositions} />;
    $[4] = deferredMarketPositions;
    $[5] = ownedPositionScope;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}